export default "__VITE_ASSET__B2kKVhBF__"